import {
  WireCoverageBase,
  WireCoverageOption,
  WireItemType,
} from 'scenes/common/api/quote/types';

export enum WireCoverageName {
  Building = 'Building',
  Contents = 'Contents',
  RentalReturn = 'RentalReturn',
}

export type WireSumInsured = {
  type: WireCoverageName;
  amount: number;
};

export type WireCoverageItemList = {
  category?: string;
  cost?: number;
  description?: string;
  isOutOfHome?: boolean;
  value: number;
};

export type WireCoverageItem = {
  name: WireItemType;
  selected: boolean;
  list: WireCoverageItemList[];
};

export type WireLandlordCoverageRequest = WireCoverageBase & {
  excessRefIds: string[];
  sumInsureds: WireSumInsured[];
  options?: WireCoverageOption[];
};

export type WireLandlordCoverageResponse = WireCoverageBase & {
  excessRefIds: string[];
  premiumRefIds: string[];
  limitRefIds: string[];
  adjustmentRefIds?: string[];
  sumInsureds?: WireSumInsured[];
};
